import {
  BonusStrategy,
  BonusType,
  BonusResult,
  ConfettiConfig,
  AmountConstraints,
} from '../interfaces/bonus.interface';

export class PorcentualBonusStrategy implements BonusStrategy {
  type = BonusType.PORCENTUAL;
  campaignSpecific = false; // Bono genérico reutilizable

  validateAmount(amount: number): boolean {
    return amount >= 1000000;
  }

  calculateBonus(amount: number, termDays: number): BonusResult {
    const terms = this.getTermsAndConditions();
    if (!this.validateAmount(amount)) {
      return {
        isValid: false,
        bonusAmount: 0,
        message: '',
        confettiType: '',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    const porcentaje = 0.003;
    const bonusAmount = Math.round(amount * porcentaje * (termDays / 360));
    const displayAmount = this.formatCurrency(bonusAmount);
    return {
      isValid: true,
      label: '+0.30%',
      value: '+0.30%',
      bonusAmount,
      message: `Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">${displayAmount}</b> extra directo a tu cuenta.`,
      message_simulador: `Puedes aplicar para un bono de ${displayAmount}. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`,
      confettiType: 'snow',
      displayAmount,
      bonusTag: 'porcentual',
      minTermDays: [30, 60, 90, 180],
      tagNameBonusType: 'PORCENTUAL',
      termsAndConditionsUrl: terms.url,
      termsAndConditionsDescription: terms.description,
    };
  }

  getTermsAndConditions(): { url: string; description: string } {
    return {
      url: 'legal/bonos/bono-porcentual',
      description:
        'Para obtener el bono del 0.3% de MejorCDT, debes ser un usuario (nuevo o existente) que inicie el proceso de apertura de un nuevo CDT haciendo clic en el enlace exclusivo de la campaña de un influencer. La promoción requiere que el CDT tenga un plazo mínimo de 12 meses y un monto de inversión igual o superior a $1,000,000 COP. Si no inicias el proceso a través del enlace del influencer, la promoción no aplicará. El bono es un cashback equivalente al 0.3% del valor total de tu inversión, que se transfiere directamente a tu cuenta bancaria personal una vez que tu CDT esté activo. Para recibir el bono, debes enviar un certificado de tu cuenta bancaria, la cual debe ser de tu titularidad y coincidir con la del CDT, ya que no se permiten transferencias a terceros. Este beneficio no es acumulable con otras promociones y se entrega un solo bono por cliente y por campaña, aplicándose sobre la primera inversión que cumpla las condiciones. MejorCDT se reserva el derecho de anular el bono si detecta cualquier tipo de actividad fraudulenta o incumplimiento de los términos.',
    };
  }

  getConfettiConfig(): ConfettiConfig {
    return {
      type: 'snow',
      duration: 4000,
      intensity: 'medium',
    };
  }

  getAmountConstraints(): AmountConstraints {
    return {
      locked: false,
      minAmount: 1000000,
    };
  }

  private formatCurrency(amount: number): string {
    return `$${amount.toLocaleString('es-CO')}`;
  }
}
